export default __webpack_public_path__ + "static/media/review.296355d6.png";